/* eslint-disable react/jsx-props-no-spreading */
import React from 'react';
import { Draggable } from 'react-beautiful-dnd';
import classNames from 'classnames';
import PropTypes from 'prop-types';

import classes from './DragItem.module.scss';

const DragItem = ({ dragId, index, children, className }) => (
  <Draggable draggableId={dragId} index={index}>
    {(provided) => (
      <div
        id="children-placeholder"
        className={classNames(classes.dragItem, className)}
        {...provided.draggableProps}
        {...provided.dragHandleProps}
        ref={provided.innerRef}
      >
        {children}
      </div>
    )}
  </Draggable>
);

DragItem.propTypes = {
  dragId: PropTypes.string.isRequired,
  index: PropTypes.number.isRequired,
  children: PropTypes.node.isRequired,
};

export default DragItem;
